export const { SITE_BASE_URL } = process.env;
export const BASE_URI_LP = `${SITE_BASE_URL}/lp`;

export const LP_WILDFIRE = `${BASE_URI_LP}/shopping-rewards`;
